import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private linkStyleElement: HTMLLinkElement | null = null;
  private linkFaviconElement: HTMLLinkElement | null = null;
  private selectedTheme: string | null = null;
  private defaultTheme: string = '1';

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setSelectedTheme(theme: string) {
    localStorage.setItem('selectedTheme', theme);
    this.selectedTheme = theme;
  }

  getSelectedTheme(): string | null {
    this.selectedTheme = this.defaultTheme;

    let selectedTheme = localStorage.getItem('selectedTheme');
    if (selectedTheme) {
      this.selectedTheme = selectedTheme;
    }
    return this.selectedTheme;
  }

  updateTheme(theme:string) {

    if (!theme) {
      theme = this.defaultTheme;
    }

    const styleMapping = {
      '1': 'assets/themes/style1.css',
      '2': 'assets/themes/style2.css',
      '3': 'assets/themes/style3.css',
      '4': 'assets/themes/style4.css',
      '5': 'assets/themes/style5.css',
      '6': 'assets/themes/style6.css',
      '7': 'assets/themes/style7.css',
      '8': 'assets/themes/style8.css',
      '9': 'assets/themes/style9.css',
      '10': 'assets/themes/style10.css',
    };

    const faviconMapping = {
      '1': 'assets/img/favicon.ico',
      '8': 'assets/img/favicon_ccg.ico',
      '9': 'assets/img/favicon.ico',
      '10': 'assets/img/favicon.ico',
    };

    const styleFile = styleMapping[theme];
    const faviconFile = faviconMapping[theme];

    if (styleFile) {

      //Style
      if (this.linkStyleElement && this.linkStyleElement.getAttribute('data-theme-id') != theme) {
        this.renderer.removeChild(document.head, this.linkStyleElement);
      }
      this.linkStyleElement = this.renderer.createElement('link');
      this.renderer.setAttribute(this.linkStyleElement, 'rel', 'stylesheet');
      this.renderer.setAttribute(this.linkStyleElement, 'type', 'text/css');
      this.renderer.setAttribute(this.linkStyleElement, 'href', styleFile);
      this.renderer.setAttribute(this.linkStyleElement, 'data-theme-id', theme);
      this.renderer.appendChild(document.head, this.linkStyleElement);

      //Favicon
      if (this.linkFaviconElement && this.linkFaviconElement.getAttribute('data-favicon-id') != theme) {
        this.renderer.removeChild(document.head, this.linkFaviconElement);
      }
      this.linkFaviconElement = this.renderer.createElement('link');
      this.renderer.setAttribute(this.linkFaviconElement, 'id', 'favicon');
      this.renderer.setAttribute(this.linkFaviconElement, 'rel', 'icon');
      this.renderer.setAttribute(this.linkFaviconElement, 'type', 'image/x-icon');
      this.renderer.setAttribute(this.linkFaviconElement, 'href', faviconFile);
      this.renderer.setAttribute(this.linkFaviconElement, 'data-theme-id', theme);
      this.renderer.appendChild(document.head, this.linkFaviconElement);
    }

  }
}
